import dayjs from 'dayjs';
import { createNamespacedHelpers } from 'vuex';

import SkeletonLoadingImage from '@/components/shared/SkeletonLoadingImage/SkeletonLoadingImage.vue';
import checkImageName from '../../../util/checkImageName';

const historyImagesMapper = createNamespacedHelpers('history/image');
const historyMapper = createNamespacedHelpers('history');
const detectorMapper = createNamespacedHelpers('detector');

const GOOD_CLASS = '0';
const MAX_LENGTH_OF_NAME = 25;
export default {
	name: 'ImageItem',

	components: {
		SkeletonLoadingImage,
	},

	data() {
		return {
			GOOD_CLASS: GOOD_CLASS,
			showOptions: false,
		};
	},

	props: {
		image: {
			type: Object,
		},

		idx: {
			type: Number,
		},

		isDetectedImage: {
			type: Boolean,
		},
		selectedImageId: String
	},

	computed: {
		noCheckBox: {
			get() {
				return this.$store.state.history.noCheckBox;
			},
			set(value) {
				this.$store.commit('history/UPDATE_NO_CHECKBOX', value);
			},
		},

		picked: {
			get() {
				return this.selectedImageId;
			},
			set(value) {
				this.$emit('on-change-selected-image-uri', value);
			},
		}
	},
	
	filters: {
		splitLongName(name) {
			return (
				name.slice(0, MAX_LENGTH_OF_NAME) +
				'....' +
				name.split('.').pop()
			);
		},

		localDateString(date) {
			if (date.includes('+') || date.includes('Z')) {
				return dayjs(date).format('YYYY/MM/DD HH:mm:ss');
			}
			return dayjs(date + 'Z').format('YYYY/MM/DD HH:mm:ss');
		},
	},

	methods: {
		checkImageName,
		...historyMapper.mapMutations(['UPDATE_SHOW_RETRAIN_TAG']),
		...historyImagesMapper.mapActions(['setIsTraning']),
		...historyImagesMapper.mapMutations(['SET_RETRAIN']),
		...detectorMapper.mapMutations(['SET_IMAGE_URI', 'SET_SHOW_CAMERA', 'SET_SHOW_CAMERA_IMG_BORDER', 'SET_SELECTED_IMAGE']),

		onChooseImage() {
			this.$emit('on-click-image', this.image);
		},

		openOptions() {
			this.showOptions = !this.showOptions;
		},

		onClickRetrainOption() {
			if (!this.image.isRetraining) this.showOptions = false;
			this.setIsTraning({
				id: this.image?._id?.$oid,
				isRetraining: true,
			});
		},
		onClickUnretrainOption() {
			if (this.image.isRetraining) this.showOptions = false;
			this.setIsTraning({
				id: this.image?._id?.$oid,
				isRetraining: false,
			});
		},

		onChange(e, image) {
			this.$emit('onCheckImage', {value: e.target.checked, image})
			this.setIsTraning({
				id: this.image?._id?.$oid,
				isRetraining: e.target.checked,
			});
			this.$forceUpdate();
		},

		eventBusListeners() {
			this.$eventBus.$on('force-update', () => {
				this.$forceUpdate();
			});
		},

		onRadioClick() {
			this.SET_SELECTED_IMAGE(this.image);
		},
	},

	mounted() {
		this.eventBusListeners();
	},
};
